module.exports = __webpack_public_path__ + "img/braip.da747630.svg";